import classNames from "classnames";
import React, { memo } from "react";
import ButtonWithTooltip from "../buttonWithTooltip";
import locale from "./saveButton.locale";
import { Button } from "UiKit";
function SaveButton(props) {
    return props.useNewBtn ? (React.createElement(Button, { styleType: "text", size: "32", disabled: props.disabled, onClick: props.onSave, iconOnly: true, tooltipMessage: locale.SAVE },
        React.createElement("i", { className: "icon-save" }))) : (React.createElement(ButtonWithTooltip, { width: props.btnSize, height: props.btnSize, className: classNames("no-border", props.className), disabled: props.disabled, onClick: props.onSave, popoverContent: locale.SAVE },
        React.createElement("i", { className: "icon-save" })));
}
export default memo(SaveButton);
SaveButton.defaultProps = {
    btnSize: 28
};
